import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-multi-notification',
  templateUrl: './multi-notification.component.html'
})
export class MultiNotificationComponent implements OnInit {
  @Input() notifications: MultiNotificationConfiguration[] = [];
  @Output() valueChange = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  public buttonClicked(event: { notification: number; action: number }) {
    this.valueChange.emit(event);
  }
}

export interface NotificationButton {
  text: string;
  type: 'primary' | 'secondary';
}

export interface MultiNotificationConfiguration {
  clicked: boolean;
  title: string;
  body: string;
  actions: NotificationButton[];
}
